import { render, staticRenderFns } from "./Fanatics.vue?vue&type=template&id=dd2b7c8a&"
import script from "./Fanatics.vue?vue&type=script&lang=js&"
export * from "./Fanatics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports